import { AxiosInstance } from 'axios';
import { requestCode } from './requestCode';
import { Toast } from '@douyinfe/semi-ui';
import useStore from '../../store';
import { TokenExpiredMiddleware } from './tokenExpiredMiddleware';
import { useNoonLoginStore } from '../../store/noonLogin';

export interface ApiResponse<T = any> {
  code: number;
  msg: string;
  data: T;
}

// axios 拦截器
export function axiosInterceptors(request: AxiosInstance) {
  // 请求拦截
  request.interceptors.request.use(
    (config) => {
      // 在发送请求之前做些什么
      const { headers } = config;
      const { token } = useStore.getState();
      // 请求头添加token
      if (token && headers) {
        headers.Token = token;
      }
      return config;
    },
    function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );

  // 响应拦截
  request.interceptors.response.use(
    (response) => {
      // 2xx 范围内的状态码都会触发该函数。
      return new Promise((resolve, reject) => {
        const { data } = response;
        const { code, message } = data;
        if (
          code === requestCode.RESULT_CODE_SUCCESS_200 ||
          code === requestCode.RESULT_CODE_SUCCESS_0
        ) {
          resolve(response);
        } else if (code === requestCode.RESULT_CODE_SUCCESS_401) {
          // Token 过期处理 - 使用独立的中间件
          TokenExpiredMiddleware.handle(
            message || '登录状态已过期，请重新登录'
          );
          reject(response);
        } else if (code === requestCode.RESULT_CODE_NOON_EXPIRED) {
          const { show } = useNoonLoginStore.getState();
          show(data.msg || 'Noon登录已过期，请重新授权', response.config);
          reject({ code: 10010, msg: data.msg });
        } else {
          console.log('message::::', message);
          resolve(response);
        }
      });
    },
    function (error) {
      // 超出 2xx 范围的状态码都会触发该函数。
      // 对响应错误做点什么
      return Promise.reject(error);
    }
  );
}
